<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="金牌石花色" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['jpFlowerColor', validatorRules.jpFlowerColor]"
            placeholder="请输入金牌石花色"
            :disabled="true"
          ></a-input>
        </a-form-item>
        <a-form-item label="系列名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['goldenStoneStoneseriesName', validatorRules.goldenStoneStoneseriesName]"
            placeholder="请输入系列名称"
            :disabled="true"
          ></a-input>
        </a-form-item>
        <a-form-item label="产品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['goldenStoneStonetypeName', validatorRules.goldenStoneStonetypeName]"
            placeholder="请输入产品名称"
            :disabled="true"
          ></a-input>
        </a-form-item>
        <a-form-item label="访问省" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['province', validatorRules.province]"
            placeholder="请输入访问省"
            :disabled="true"
          ></a-input>
        </a-form-item>
        <a-form-item label="访问市" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['city', validatorRules.city]" placeholder="请输入访问市" :disabled="true"></a-input>
        </a-form-item>
        <a-form-item label="访问区" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['county', validatorRules.county]"
            placeholder="请输入访问区"
            :disabled="true"
          ></a-input>
        </a-form-item>
        <a-form-item label="访问时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date
            placeholder="请选择访问时间"
            v-decorator="['createDate', validatorRules.createDate]"
            :trigger-change="true"
            :show-time="true"
            date-format="YYYY-MM-DD HH:mm:ss"
            style="width: 100%"
            :disabled="true"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import JDate from '@/components/jeecg/JDate'

export default {
  name: 'GoldStoneJpglistsVisitLogModal',
  components: {
    JDate,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        city: { rules: [] },
        county: { rules: [] },
        createDate: { rules: [] },
      },
      url: {
        add: '/jujiastone/goldStoneJpglistsVisitLog/add',
        edit: '/jujiastone/goldStoneJpglistsVisitLog/edit',
      },
    }
  },
  created() {},
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'jpFlowerColor',
            'goldenStoneStoneseriesName',
            'goldenStoneStonetypeName',
            'province',
            'city',
            'county',
            'createDate'
          )
        )
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'post'
          }
          let formData = Object.assign(this.model, values)
          console.log('表单提交数据', formData)
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'jpFlowerColor',
          'goldenStoneStoneseriesName',
          'goldenStoneStonetypeName',
          'province',
          'city',
          'county',
          'createDate'
        )
      )
    },
  },
}
</script>
